import { useEffect, useState } from 'react';

export const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 0
    );

    useEffect(() => {
        const handleResize = () =>
            setWindowWidth(typeof window !== 'undefined' ? window.innerWidth : 0);

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        windowWidth,
        desktop: windowWidth >= 1024,
        tablet: windowWidth >= 768 && windowWidth < 1024,
        mobile: windowWidth < 768,
    };
};
